<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="交易日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="交易日期"></el-date-picker>
                </div>
                <div class="reset fcolor" @click="resetSearch">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <div class="execlInsert clearfix">
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
                <div class="header_row_return" @click="backList">
                    返回列表
                </div>
            </div>
            <!-- <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked">删除</el-button>
            </div> -->
            <div class="tableBox">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" @getTableDelete="getTableDelete" :tabledata="list" @getRow="getRow"  @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber">合计：</div>
                <div class="totalNumber">付款金额： {{totalObj.amount}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .execlInsert{right: 80px;top: 10px;}
    .header_row_return{float: right;font-size: 14px;font-weight: 600;}
    .search_box{padding-right:10px;}
    .search_box{padding-bottom:10px;}
    .detailTitle{float: left;line-height: 33px;}
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                id:"",
                start_time: "",
                end_time: "",
                params:{
                    start_time:"",
                    end_time:"",
                    issuing_id:'',
                    per_page: 50,
                    page:1
                },
                bill:{},
                trading_time:"",
                selectMap:{
                    customer:[],
                    user:[],
                    account:[],
                    paymentType:[],
                    supplier:[],
                    currency:[],
                    operatorOptions:[]
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                list : [],
                tableCol:[	
                    {colName:"交易日期",colKey:"trading_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"科目名称",colKey:"course_title",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"付款账户",colKey:"account_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"付款方式",colKey:"payment_type_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"收款方",colKey:"issuing_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"付款金额",colKey:"inout_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"起息日",colKey:"start_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"结息日",colKey:"end_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"计息天数",colKey:"days",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"操作人",colKey:"operator_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true}
                ],
                selectRow:[],
                totalObj:{},
               
            }
        },
        created(){
            if(sessionStorage.DEMU_ERP_INTEREST_ID){
                this.id=sessionStorage.DEMU_ERP_INTEREST_ID;
                this.params.issuing_id=sessionStorage.DEMU_ERP_INTEREST_ID;
                sessionStorage.removeItem("DEMU_ERP_INTEREST_ID")
            }
            
            this.getList();
        },
        methods:{
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            backList(){
                this.$root.$children[0].$children[0].showTab({
                    label: "开证公司管理",
                    name: "开证公司管理",
                    content: "customerIssueManagement",
                });
            },
            excelExport() {
                this.$exportExecl("/erp/issuing.interest.bill.export", "实付利息明细", this.params)
            },
            getTableDelete(id){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/issuing.interest.bill.delete",{id:id},()=>{
                        this.tip("删除成功","success")
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.postFunc("/erp/issuing.interest.bill.list",this.params,res=>{
                    console.log(res)
                    this.last_page=parseInt(res.data.data.data.last_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.list=res.data.data.data.data;
                    this.totalObj=res.data.data.data.total;
                    this.list.forEach((item,index)=>{
                        item.images = item.files;
                        item.isDelete=true;
                        // item.isEdit = true;
                        if(item.trading_time==0){
                            this.list[index].trading_time = "";
                        }else{
                            this.list[index].trading_time = this.formatTime(item.trading_time+"000")
                        }
                        if(item.start_time==0){
                            this.list[index].start_time = "";
                        }else{
                            this.list[index].start_time = this.formatTime(item.start_time+"000")
                        }
                        if(item.end_time==0){
                            this.list[index].end_time = "";
                        }else{
                            this.list[index].end_time = this.formatTime(item.end_time+"000")
                        }
                       
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
               
            },
            getRow(row){
                this.selectRow=row;
            },
            resetSearch(){
                this.start_time='';
                this.end_time='';
                this.params={ 
                    start_time:"",
                    end_time:"",
                    issuing_id: this.params.issuing_id,
                    per_page: 50,
                    page:1
                }
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
           
        }
    }
</script>
